export const ReceiptTemplate = `<!DOCTYPE html>
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <meta http-equiv="X-UA-Compatible" content="ie=edge">
  <style>
    @page{
      margin: 0;
    }
    * {
      font-family: sans-serif;
      font-size: 12px;
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }

    .fsmall {
      font-size: 8px;
    }
    .freg {
      font-size: 10px;
    }
    .flarge {
      font-size: 14px;
    }
    .ftitle {
      font-size: 18px;
    }
    .f-bold {
      font-weight: bold;
    }
    .f-center {
      text-align: center;
    }
    .font-transparent {
      color: transparent;
    }

    .receipt {
      width: 100%;
      display: flex;
      flex-direction: column;
      padding: 5px 20px;
    }

    .receipt-header {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 10px;
      margin-bottom: 10px;
    }

    .receipt-info {
      margin-bottom: 10px;
    }

    .receipt-products {
      flex-grow: 1;
    }

    .left-width {
      width: 50%
    }
    
    .w-100 {
      width: 100%;
    }
    .w-33 {
      width: 33%;
    }
    .w-22 {
      width: 22%;
    }
    .quarter {
      width: 24%;
    }
    .d-flex {
      display: flex;
    }
    .fl-col {
      flex-direction: column;
    }
    .fl-jsb {
      justify-content: space-between;
    }
    .fl-jc {
      justify-content: center;
    }
    .fl-se {
      justify-content: space-evenly;
    }
    .fl-jsa {
      justify-content: space-around;
    }
    .fl-ac {
      align-items: center;
    }
    .fl-ae {
      align-items: flex-end;
    }
    .fl-grow {
      flex-grow: 1;
    }

    .mb-10 {
      margin-bottom: 10px;
    }

    .belgium-header {
      margin-bottom: 5px;
    }

    /* FDM signatures are 40 hex chars and must not run off the paper */
    .no-overflow {
      overflow-wrap: break-word;
      word-break: break-all;
    }

    .mb-5 {
      margin-bottom: 5px;
    }

    .mt-5 {
      margin-top: 5px;
    }
    .pb-10 {
      padding-bottom: 10px;
    }
    .pt-10 {
      padding-top: 10px;
    }

    .pr-10 {
      padding-right: 10px;
    }
    .pl-10 {
      padding-left: 10px;
    }
    .mb-title {
      margin-bottom: 20px;
    }
    .mb-large {
      margin-bottom: 30px;
    }

    .border-bottom {
      border-bottom: 1px solid;
    }

    .border-bottom-bold {
      border-bottom: 2px solid;
    }

    .border-top {
      border-top: 1px solid;
    }

    .dushed-border{
      border: 1px dashed;
      border-left: none;
      border-right: none;
    }

    .qrcode-container {
      width:140px;margin:auto; margin-bottom:10px;display:flex;flex-direction:column;justify-content:center;align-items:center;
    }
    .qrcode img{
      width: 100%;
      height: 100%;
    }

    .france-header{
      margin-bottom: 5px;
    }

  </style>
</head>
<body>
  <div class="receipt">
    <div class="receipt-header freg">
      <div class="ftitle f-bold f-center mb-5">{{> headerName}}</div>
      <div class="mb-title f-center" style="display:flex; flex-direction:column;">
        {{> headerBusinessId}}
      </div>
      
      <div class="freg mb-5">{{ groupInfo.address }}
        {{#if franceAdditionalInfo}}
        {{!-- printing country is required in france --}}
        , {{ groupInfo.country }}
        {{/if}}
        {{#if belgiumAdditionalInfo}}
        {{!-- and in belgium --}}
        , {{ groupInfo.country }}
        {{/if}}
      </div>
      
      <div class="freg mb-title">Tel: {{ groupInfo.phone }}</div>
      {{> headerReprintLabels}}
      
    </div>

    <div class="receipt-info">
      {{> receiptInfoFrance}}
      {{!-- BE prints its fiscal block above the rule, then Ref and Session ID
            below it, which is the layout the FPS certified --}}
      {{> receiptInfoBelgium}}
      {{> dateSellerRow}}
      <hr class="mb-10">
      <div class="d-flex fl-jsb mb-10">
        <div>Ref:</div>
        <div> <span class="f-bold">{{ bookingRef }}</span></div>
      </div>
      {{#if sessionId}}
      <div class="d-flex fl-jsb mb-10">
        <div>{{t "field.session-id"}}:</div>
        <div> <span class="f-bold">{{ sessionId }}</span></div>
      </div>
      {{/if}}
      {{#if orderSessionReference}}
      <div class="d-flex fl-jsb mb-10" id="receipt-counter">
        <div>{{t "field.session-id"}}:</div>
        <div> <span class="f-bold">{{ orderSessionReference }}</span></div>
      </div>
      {{/if}}

      {{> receiptInfoAustria}}
      {{> receiptInfoCroatia}}

      <hr>
    </div>

    {{#if croatiaAdditionalInfo.customerName}}
    <div class="mb-10 freg">
      <div class="f-bold">{{ croatiaAdditionalInfo.customerName }}</div>
      {{#if croatiaAdditionalInfo.customerAddress}}
      <div>{{ croatiaAdditionalInfo.customerAddress }}</div>
      {{/if}}
    </div>
    <hr class="mb-10">
    {{/if}}

    <div class="receipt-products">
      {{#each products}}
      <div class="mb-10">
        <div class="product d-flex">
          <div class="d-flex fl-col" style="width: 50%">
            <div>{{this.name}}</div>
            <div class="fsmall">{{ this.priceName }}</div>
            <div class="fsmall">{{ this.startDateTime }}</div>
            {{!-- BE: the certified line shows the quantity and total only --}}
            {{#unless ../belgiumAdditionalInfo}}
            <div>{{ this.quantity }}x {{this.unitPrice}}</div>
            {{/unless}}
          </div>
          <div class="d-flex fl-col fl-jc" style="width: 10%"><div>x{{ this.quantity }}</div></div>
          <div class="d-flex fl-col fl-ae fl-jc fl-grow">
            <div>
            <span class="freg"> {{this.vatIndex}} </span>
              &nbsp {{ this.priceValue }} 
            </div>
          </div>        </div>
        {{#if hasCancelledTickets}}
        <div class="d-flex mt-5">
          <div class="d-flex fl-col" style="width: 50%">
            <div class="freg">{{t "receipt.cancelled"}}</div>
          </div>
        </div>
        {{/if}}
        {{#if discountValue}}
        <div class="d-flex mt-5">
          <div class="d-flex fl-col" style="width: 50%">
            <div class="freg">{{t "discount.discount"}}</div>
          </div>
          <div class="d-flex fl-col fl-ae fl-jc fl-grow"><div>{{this.discountPercentage}}% / {{ this.discountValue }} </div></div>
        </div>
        {{/if}}
      </div>
      {{/each}}
    </div>

    <hr class="mb-10">

    <div class="receipt-total">
      {{#if discountTotal}}
      <div class="mb-10">
        <div class="d-flex">
          <div class="left-width">{{t "discount.discount"}}</div>
          <div class="d-flex fl-jsb fl-grow">
            <div class="d-flex fl-jsb fl-grow pb-10">
              <div>{{ currency }} </div>
              <div>-{{ this.discountTotal }} </div>
            </div>
          </div>
        </div>
      </div>
      {{/if}}

      <div class="d-flex mb-10 fl-ae">
        <div class="left-width">{{#if belgiumAdditionalInfo}}{{t "field.subtotal"}}{{else}}{{t "dashboards.total-ht"}}{{/if}}</div>
        <div class="d-flex fl-jsb fl-grow pt-10">
          <div>{{ currency }} </div>
          <div>{{ netTotal }} </div>
        </div>
      </div>
      <div class="d-flex mb-10 fl-ae">
        <div class="left-width flarge">{{t "field.vat"}}</div>
        <div class="border-bottom-bold d-flex fl-jsb fl-grow pt-10">
          <div>{{ currency }} </div>
          <div>{{ taxTotal }} </div>
        </div>
      </div>

      {{!-- BE: a session that settles a balance without adding tickets --}}
      {{#if remainingBalance}}
      <div class="d-flex mb-10 fl-ae">
        <div class="left-width">{{t "field.remaining-balance"}}</div>
        <div class="d-flex fl-jsb fl-grow pt-10">
          <div>{{ currency }} </div>
          <div>{{ remainingBalance }} </div>
        </div>
      </div>
      {{/if}}

      <div class="d-flex mb-10 fl-ae">
        <div class="left-width">{{#if belgiumAdditionalInfo}}{{t "field.total"}}{{else}}{{t "dashboards.total-ttc"}}{{/if}}</div>
        <div class="d-flex fl-jsb fl-grow pt-10">
          <div class="flarge f-bold">{{ currency }} </div>
          <div class="flarge f-bold">{{ total }} </div>
        </div>
      </div>
    </div>
    <hr class="mb-10">
    <div class="mb-10">
    {{#each payments}}
    <div class="d-flex fl-jsb mb-10 pr-10 pl-10">
      <div style="width: 55%;">{{ this.name }}</div>
      <div class="d-flex f-reg" style="width: 45%">
        <div>{{ this.currency }} </div>
      </div>
      <div class="d-flex f-reg w-33" style="gap:15px;justify-content:flex-end;">
        {{#if this.providedCashBill}}
        <div>{{ this.providedCashBill }}</div>
        <div>{{ this.exchangeRate }}</div>
        {{/if}}
        <div>{{ this.value }}</div>
      </div>
      
      
    </div>
    {{/each}}
    </div>

    <div class="mb-large pt-10 pb-10 dushed-border">
      <div class="d-flex mb-5">
        <div class="font-transparent w-33"></div>
        <div class="w-22 f-center">{{t "field.vat"}}</div>
        <div class="w-22 f-center">{{t "field.order-total-excl-tax"}}</div>
        <div class="w-22 f-center">{{t "field.order-total-incl-tax"}}</div>
      </div>
      {{#unless vats}}
      {{!-- rendered in case of no vats --}}
      <div class="d-flex mb-5">
        <div class="w-33">{{t "field.vat"}} (0.00%)</div>
        <div class="w-22 f-center">0.00</div>
        <div class="w-22 f-center">{{ total }}</div>
        <div class="w-22 f-center">{{ total }}</div>
      </div>
      {{/unless}}
      {{#each vats}}
        <div class="d-flex mb-5">
          {{#if this}}
            <div class="w-33  d-flex fl-jsb">
              <span class="freg"> 
                {{this.vatIndex}} 
                {{#if ../printVatLineLabels}}
                  {{#if (eq this.type 1)}}
                    {{t "field.purchase"}}
                  {{else}}
                    {{t "field.return"}}
                  {{/if}}

                {{/if}}
                
                </span>
              ({{ this.rate }})
            </div>
            <div class="w-22 f-center">{{ this.vatAmount }}</div>
            <div class="w-22 f-center">{{ this.amountExclVat }}</div>
            <div class="w-22 f-center">{{ this.amountInclVat }}</div>
          {{/if}}
        </div>
      {{/each}}
    </div>

    {{#if paymentDetails}}
    <div class="mb-10">
      <div class="d-flex fl-jsb freg">
        <div class="d-flex fl-col fl-ac f-reg">
          <div>{{t "payment.transaction"}}</div>
          <div>{{ paymentDetails.date }}</div>
        </div>
        <div class="d-flex fl-col fl-ae f-reg fl-jc">
          <div>{{ paymentDetails.time }}</div>
        </div>
      </div>
    </div>

    <div class="mb-10">
      <div class="d-flex fl-jsb freg">
        <div style="width: 55%;"> {{paymentDetails.posEntryMode}} </div>
        <div class="d-flex fl-col fl-ae f-reg">
          <div>{{ paymentDetails.paymentMethod }}</div>
        </div>
      </div>

      <div class="d-flex fl-jsb freg">
        <div style="width: 55%;"> {{t "payment.card"}} </div>
        <div class="d-flex fl-col fl-ae f-reg">
          <div>{{ paymentDetails.card }}</div>
        </div>
      </div>

      <div class="d-flex fl-jsb freg">
        <div style="width: 55%;"> {{t "payment.status"}} </div>
        <div class="d-flex fl-col fl-ae f-reg">
          <div>{{ paymentDetails.status }}</div>
        </div>
      </div>
    </div>

    <div class="mb-10">
      <div class="d-flex fl-jsb freg">
        <div style="width: 55%;"> Auth Code </div>
        <div class="d-flex fl-col fl-ae f-reg">
          <div>{{ paymentDetails.authCode }}</div>
        </div>
      </div>

      <div class="d-flex fl-jsb freg">
        <div style="width: 55%;"> Tender </div>
        <div class="d-flex fl-col fl-ae f-reg">
          <div>{{ paymentDetails.tender }}</div>
        </div>
      </div>

      <div class="d-flex fl-jsb freg">
        <div style="width: 55%;"> {{t "orders.reference"}} </div>
        <div class="d-flex fl-col fl-ae f-reg">
          <div>{{ paymentDetails.reference }}</div>
        </div>
      </div>
    </div>

    <div class="mb-10">
      <div class="d-flex fl-jsb freg">
        <div class="f-bold"> {{t "dashboards.total-ttc"}} {{ paymentDetails.currency }} </div>
        <div class="d-flex fl-col fl-ae f-reg flarge f-bold">
          <div>{{ paymentDetails.total }}</div>
        </div>
      </div>
    </div>

    <div class="mb-10">
      <div class="d-flex fl-jsb freg">
        <div style="width: 55%;"> AID </div>
        <div class="d-flex fl-col fl-ae f-reg">
          <div>{{ paymentDetails.AID }}</div>
        </div>
      </div>

      <div class="d-flex fl-jsb freg">
        <div style="width: 55%;"> MID </div>
        <div class="d-flex fl-col fl-ae f-reg">
          <div>{{ paymentDetails.MID }}</div>
        </div>
      </div>

      <div class="d-flex fl-jsb freg">
        <div style="width: 55%;"> TID </div>
        <div class="d-flex fl-col fl-ae f-reg">
          <div>{{ paymentDetails.TID }}</div>
        </div>
      </div>

      <div class="d-flex fl-jsb freg">
        <div style="width: 55%;"> PTID </div>
        <div class="d-flex fl-col fl-ae f-reg">
          <div>{{ paymentDetails.PTID }}</div>
        </div>
      </div>
    </div>
      {{/if}}

    {{> signatureFooter}}

    {{#if isBill}}
      <div class="d-flex fl-jc fsmall mb-5">
        <span class="freg">{{ t "receipt.bill-disclaimer" }}</span>
      </div>
    {{/if}}

    <div class="d-flex fl-jc fsmall">
      <span class="freg">{{t "receipt.thanks"}}</span>
    </div>
  </div>
</body>`;

export const ClosingReceiptTemplate = `<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <meta http-equiv="X-UA-Compatible" content="ie=edge" />
  <style>
    @page{ margin: 0; } * { font-family: sans-serif; font-size: 12px; margin: 0;
    padding: 0; box-sizing: border-box; } .freg { font-size: 10px; } .ftitle {
    font-size: 18px; } .ftitle-small { font-size: 15px; } .f-bold { font-weight:
    bold; } .f-center { text-align: center; } .receipt { width: 100%; display:
    flex; flex-direction: column; padding: 5px 20px; } .receipt-header {
    display: flex; flex-direction: column; align-items: center; padding-top:
    10px; margin-bottom: 10px; } .receipt-info { margin-bottom: 10px; } .w-33 {
    width: 33% } .w-55 { width: 55% } .left-width { width: 50% } .w-50 { width:
    50% } .w-100 { width: 100%; } .d-flex { display: flex; } .fl-col {
    flex-direction: column; } .fl-jsb { justify-content: space-between; } .fl-jc
    { justify-content: center; } .fl-ac { align-items: center; } .fl-ae {
    align-items: flex-end; } .mb-5 { margin-bottom: 5px; } .mb-10 {
    margin-bottom: 10px; } .mb-title { margin-bottom: 20px; }
  </style>
</head>
<body>
  <div class="receipt">
    <div class="receipt-header freg">
      <div class="ftitle f-bold f-center">{{groupInfo.name}}</div>
      <div class="mb-title">
        {{businessIdField}}:
        {{#if groupInfo.vatNumber}}
          {{ groupInfo.vatNumber }}
        {{else}}
          {{ groupInfo.registrationNum }}
        {{/if}}
      </div>

      <div class="freg">{{groupInfo.address}}</div>
      <div class="freg mb-title">Tel: {{groupInfo.phone}}</div>
    </div>

    <div class="receipt-info">
      <div class="d-flex fl-jsb mb-10 freg">
        <div style="width: 45%;">{{impressionDate.key}}</div>
        <div class="d-flex fl-col fl-ae f-reg">
          <div>{{impressionDate.value}}</div>
        </div>
      </div>
      <div class="d-flex fl-jsb mb-10 freg">
        <div style="width: 45%;">{{openingDate.key}}</div>
        <div class="d-flex fl-col fl-ae f-reg">
          <div>{{openingDate.value}}</div>
        </div>
      </div>
      <div class="d-flex fl-jsb mb-10 freg">
        <div style="width: 45%;">{{closingDate.key}}</div>
        <div class="d-flex fl-col fl-ae f-reg">
          <div>{{closingDate.value}}</div>
        </div>
      </div>
      <div class="d-flex fl-jsb freg mb-10">
        <div style="width: 55%;">{{seller.key}}</div>
        <div class="d-flex fl-col fl-ae f-reg">
          <div>{{seller.value}}</div>
        </div>
      </div>
      <hr class="mb-10" />

      <div class="d-flex fl-jsb freg">
        <div style="width: 55%;">{{cf.key}}</div>
        <div class="d-flex fl-col fl-ae f-reg">
          <div>{{cf.value}}</div>
        </div>
      </div>
    </div>

    <hr class="mb-10" />
    {{#each currencies}}
    <div class="ftitle-small f-bold mb-10">{{../subTitle}} {{this.label}}</div>

    {{#if ../hasCashTransfersLogic}}
      <div class="mb-10">
        <div class="d-flex fl-jsb freg mb-5">
            <div style="width: 55%;">{{../initialCashFloats.key}}</div>
            <div class="d-flex fl-col fl-ae f-reg">
              <div>{{this.label}}</div>
            </div>
            <div class="d-flex fl-col fl-ae f-reg w-33">
              <div>{{lookup ../initialCashFloats.values this.label}}</div>
            </div>
          </div>

        <div class="d-flex fl-jsb freg mb-5">
          <div style="width: 55%;">{{../ttlCashIn.key}}</div>
          <div class="d-flex fl-col fl-ae f-reg">
            <div>{{this.label}}</div>
          </div>
          <div class="d-flex fl-col fl-ae f-reg w-33">
            <div>{{../ttlCashIn.value}}</div>
          </div>
        </div>
        <div class="d-flex fl-jsb freg mb-5">
          <div style="width: 55%;">{{../ttlCashOut.key}}</div>
          <div class="d-flex fl-col fl-ae f-reg">
            <div>{{this.label}}</div>
          </div>
          <div class="d-flex fl-col fl-ae f-reg w-33">
            <div>{{../ttlCashOut.value}}</div>
          </div>
        </div>
        <div class="d-flex fl-jsb freg mb-5">
          <div style="width: 55%;">{{../expectedCashfloat.key}}</div>
          <div class="d-flex fl-col fl-ae f-reg">
            <div>{{this.label}}</div>
          </div>
          <div class="d-flex fl-col fl-ae f-reg w-33">
            <div>{{../expectedCashfloat.value}}</div>
          </div>
        </div>
        <div class="d-flex fl-jsb freg mb-5">
          <div style="width: 55%;">{{../addedCashfloat.key}}</div>
          <div class="d-flex fl-col fl-ae f-reg">
            <div>{{this.label}}</div>
          </div>
          <div class="d-flex fl-col fl-ae f-reg w-33">
            <div>{{../addedCashfloat.value}}</div>
          </div>
        </div>
        <div class="d-flex fl-jsb freg mb-5">
          <div style="width: 55%;">{{../difference.key}}</div>
          <div class="d-flex fl-col fl-ae f-reg">
            <div>{{this.label}}</div>
          </div>
          <div class="d-flex fl-col fl-ae f-reg w-33">
            <div>{{../difference.value}}</div>
          </div>
        </div>
        {{#if (lookup ../messages.values this.label)}}
          <div class="d-flex fl-jsb freg mb-5">
              <div style="width: 55%;">{{../messages.key}}</div>
              <div class="d-flex fl-col fl-ae f-reg w-33">
                <div>{{lookup ../messages.values this.label}}</div>
              </div>
          </div>
        {{/if}}
      </div>
    {{/if}}

    {{#unless ../hasCashTransfersLogic}}
      {{! rendered in case of no hasCashTransfersLogic }}
      <div class="mb-10">
        <div class="d-flex fl-jsb freg mb-5">
            <div style="width: 55%;">{{../initialCashFloats.key}}</div>
            <div class="d-flex fl-col fl-ae f-reg">
              <div>{{this.label}}</div>
            </div>
            <div class="d-flex fl-col fl-ae f-reg w-33">
              <div>{{lookup ../initialCashFloats.values this.label}}</div>
            </div>
        </div>
        <div class="d-flex fl-jsb freg mb-5">
            <div style="width: 55%;">{{../totalCashSalesByCurrency.key}}</div>
            <div class="d-flex fl-col fl-ae f-reg">
              <div>{{this.label}}</div>
            </div>
            <div class="d-flex fl-col fl-ae f-reg w-33">
              <div>{{lookup ../totalCashSalesByCurrency.values this.label}}</div>
            </div>
        </div>
        {{#if (lookup ../changeGivenBack.values this.label)}}
          <div class="d-flex fl-jsb freg mb-5">
              <div style="width: 55%;">{{../changeGivenBack.key}}</div>
              <div class="d-flex fl-col fl-ae f-reg">
                <div>{{this.label}}</div>
              </div>
              <div class="d-flex fl-col fl-ae f-reg w-33">
                <div>{{lookup ../changeGivenBack.values this.label}}</div>
              </div>
          </div>
        {{/if}}
        <div class="d-flex fl-jsb freg mb-5">
            <div style="width: 55%;">{{../finalCashFloats.key}}</div>
            <div class="d-flex fl-col fl-ae f-reg">
              <div>{{this.label}}</div>
            </div>
            <div class="d-flex fl-col fl-ae f-reg w-33">
              <div>{{lookup ../finalCashFloats.values this.label}}</div>
            </div>
        </div>

        <div class="d-flex fl-jsb freg mb-5">
            <div style="width: 55%;">{{../cashDifferences.key}}</div>
            <div class="d-flex fl-col fl-ae f-reg">
              <div>{{this.label}}</div>
            </div>
            <div class="d-flex fl-col fl-ae f-reg w-33">
              <div>{{lookup ../cashDifferences.values this.label}}</div>
            </div>
        </div>
        {{#if (lookup ../messages.values this.label)}}
          <div class="d-flex fl-jsb freg mb-5">
              <div style="width: 55%;">{{../messages.key}}</div>
              <div class="d-flex fl-col fl-ae f-reg w-33">
                <div>{{lookup ../messages.values this.label}}</div>
              </div>
          </div>
        {{/if}}
    {{/unless}}
    {{/each}}
    {{#if message.value}}
        <div class="d-flex fl-jc">
      <div class="w-50 f-bold">
        <div class="f-center">{{message.key}}</div>
      </div>
      <div class="w-50">
        <div>
          {{message.value}}
        </div>
      </div>
    </div>
    {{/if}}
  </div>
</body>`;

export const ClosingSummaryReceiptTemplate = `<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <meta http-equiv="X-UA-Compatible" content="ie=edge" />
  <style>
    @page{ margin: 0; } * { font-family: sans-serif; font-size: 10px; margin: 0;
    padding: 0; box-sizing: border-box; } .freg { font-size: 8px; } .ftitle {
    font-size: 16px; } .ftitle-small { font-size: 12px; } .f-bold { font-weight:
    bold; } .f-center { text-align: center; } .receipt { width: 100%; display:
    flex; flex-direction: column; padding: 5px 20px; } .receipt-header {
    display: flex; flex-direction: column; align-items: center; padding-top:
    10px; margin-bottom: 10px; } .receipt-info { margin-bottom: 10px; } .w-33 {
    width: 33% } .w-55 { width: 55% } .left-width { width: 50% } .w-50 { width:
    50% } .w-100 { width: 100%; } .d-flex { display: flex; } .fl-col {
    flex-direction: column; } .fl-jsb { justify-content: space-between; } .fl-jc
    { justify-content: center; } .fl-ac { align-items: center; } .fl-ae {
    align-items: flex-end; } .mb-5 { margin-bottom: 5px; } .mb-10 {
    margin-bottom: 10px; } .mb-title { margin-bottom: 20px; }
    .divider {
    	border-bottom: 1px dotted black;
    	margin-bottom: 10px;
    }
    .pl-10 {
      padding-left: 10px;
    }

    .beta {
    	font-size: 12px;
        margin-bottom: 40px;
    }

    .total {
    	border-top: 1px dotted black;
    }

    .mb-20 {
      margin-bottom: 20px;
    }
    .pt-10 {
      padding-top: 10px;
    }
    .pb-10 {
      padding-bottom: 10px;
    }

    .border-top {
      border-top: 1px dotted black;
    }

  </style>
</head>
<body>
  <div class="receipt">
    <div class="receipt-header freg">
      <div class="ftitle f-bold f-center mb-10">{{groupInfo.name}}</div>
      <div class="freg">{{groupInfo.address}}</div>
      <div class="freg mb-title">Tel: {{groupInfo.phone}}</div>
      <div class="mb-title">
        {{businessId.key}}: {{ businessId.value }}
      </div>
      <div class="ftitle f-bold">*************************</div>
    </div>

    <div class="divider"></div>
    <div class="ftitle f-bold">{{ closureDetailsField }}</div>
    <div class="divider"></div>
    <div class="mb-10"></div>

    <div class="receipt-info">
      <div class="d-flex fl-jsb mb-10 freg">
        <div style="width: 40%;">{{ openendBy.key }}</div>
        <div style="width: 30%;">{{ openendBy.value }}</div>
        <div style="width: 30%; text-align: right;">{{ openingDate.value }}</div>
      </div>
      <div class="d-flex fl-jsb mb-10 freg">
        <div style="width: 40%;">{{ closedBy.key }}</div>
        <div style="width: 30%;">{{ closedBy.value }}</div>
        <div style="width: 30%; text-align: right;">{{ closingDate.value }}</div>
      </div>

      <div class="d-flex fl-jsb mb-10 freg">
        <div style="width: 30%;">{{ printDate.key }}</div>
        <div style="width: 30%; text-align: right;">{{ printDate.value }}</div>
      </div>

      <div class="mb-20"></div>

      {{#if device.key}}
      <div class="d-flex fl-jsb freg mb-10">
        <div style="width: 55%;">{{ device.key }}</div>
        <div>{{ device.value }}</div>
      </div>
      {{/if}}
      <div class="d-flex fl-jsb freg mb-10">
        <div style="width: 55%;">{{ cashfloatUid.key }}</div>
        <div>{{ cashfloatUid.value }}</div>
      </div>
    </div>

    <div class="payment-summary-section mb-10">
      <div class="divider"></div>
      <div class="ftitle f-bold">{{paymentSummary.title}}</div>
      <div class="divider"></div>
      <div class="mb-20"></div>

      <div class="d-flex fl-jsb freg mb-5 pl-10" >
        <div class="f-bold" style="width: 39%;">{{paymentSummary.headers.[0]}}</div>
        <div class="d-flex fl-jsb" style="width: 51%; text-align: right;">
          {{#each paymentSummary.headers}}
            {{#if @index}} <!-- Skip index 0 -->
              <div class="f-bold freg" style="width: 17%;">{{this}}</div>
            {{/if}}
          {{/each}}
        </div>
      </div>
      <div class="divider"></div>

      {{#each paymentSummary.sections as |section|}}
       <div class="mb-20">
        <div class="d-flex fl-jsb freg pl-10" >
          <div class="f-bold" style="width: 49%;">{{section.headers.[0]}}</div>
        </div>
        <div class="divider"></div>

        <!-- Line entries -->
        {{#each section.lines as |line|}}
          <div class="d-flex fl-jsb freg mb-5 pl-10">
            <div class="{{#if line.columns.[0].isBold}}f-bold{{/if}}" style="width: 49%;">{{line.label}}</div>
            <div class="d-flex fl-jsb" style="width: 51%; text-align: right;">
            {{#each line.columns as |col colIndex|}}
              <div class="{{#if col.isBold}}f-bold{{/if}}" style="width: 17%;">{{col.value}}</div>
            {{/each}}
            </div>
          </div>
        {{/each}}
      </div>
      {{/each}}

      <div class="mb-10"></div>
      <div class="mb-10"></div>
    </div>
    <div class="mb-10"></div>


    <div class="divider"></div>
    <div class="ftitle f-bold">{{ salesDetailsField }}</div>
    <div class="divider"></div>
    <div class="mb-10"></div>

    {{#each paymentMethodSections as |section|}}
      <div class="payment-method-section mb-10">
        <div class="f-bold mb-5">{{section.title}}</div>
        {{#each section.lines as |line|}}
          <div class="d-flex fl-jsb freg mb-5 pl-10 {{#if line.isBold}}f-bold{{/if}} {{#if line.hasBorder}}border-top{{/if}} {{#if line.marginTop}}pt-10{{/if}} {{#if line.marginBottom}}pb-10{{/if}}">
              <div style="width: 50%;">{{line.label}}</div>
              <div class="d-flex fl-jsb" style="width: 50%">
                <div class="d-flex fl-col fl-ae f-reg">
                  <div>{{line.currency}}</div>
                </div>
                <div class="d-flex fl-col fl-ae f-reg w-33">
                  <div>{{line.value}}</div>
                </div>
              </div>
          </div>
        {{/each}}
      </div>
      <div class="mb-10"></div>
    {{/each}}

  </div>
</body>`;

export const orderSummaryReceipt = `
<!DOCTYPE html>
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <meta http-equiv="X-UA-Compatible" content="ie=edge" />
  <style>
    @page {
      margin: 0;
    }
    * {
      font-family: sans-serif;
      font-size: 12px;
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }

    .fsmall {
      font-size: 8px;
    }
    .freg {
      font-size: 10px;
    }
    .flarge {
      font-size: 14px;
    }
    .ftitle {
      font-size: 18px;
    }
    .f-bold {
      font-weight: bold;
    }
    .f-center {
      text-align: center;
    }
    .font-transparent {
      color: transparent;
    }

    .receipt {
      width: 100%;
      display: flex;
      flex-direction: column;
      padding: 5px 20px;
    }

    .receipt-header {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 10px;
      margin-bottom: 10px;
    }

    .receipt-info {
      margin-bottom: 10px;
    }

    .receipt-products {
      flex-grow: 1;
    }

    .left-width {
      width: 50%;
    }

    .w-100 {
      width: 100%;
    }
    .w-33 {
      width: 33%;
    }
    .w-22 {
      width: 22%;
    }
    .quarter {
      width: 24%;
    }
    .d-flex {
      display: flex;
    }
    .fl-col {
      flex-direction: column;
    }
    .fl-jsb {
      justify-content: space-between;
    }
    .fl-jc {
      justify-content: center;
    }
    .fl-se {
      justify-content: space-evenly;
    }
    .fl-jsa {
      justify-content: space-around;
    }
    .fl-ac {
      align-items: center;
    }
    .fl-ae {
      align-items: flex-end;
    }
    .fl-grow {
      flex-grow: 1;
    }

    .mb-10 {
      margin-bottom: 10px;
    }

    .mb-5 {
      margin-bottom: 5px;
    }

    .mt-5 {
      margin-top: 5px;
    }
    .pb-10 {
      padding-bottom: 10px;
    }
    .pt-10 {
      padding-top: 10px;
    }

    .pr-10 {
      padding-right: 10px;
    }
    .pl-10 {
      padding-left: 10px;
    }
    .mb-title {
      margin-bottom: 20px;
    }
    .mb-large {
      margin-bottom: 30px;
    }

    .border-bottom {
      border-bottom: 1px solid;
    }

    .border-bottom-bold {
      border-bottom: 2px solid;
    }

    .border-top {
      border-top: 1px solid;
    }

    .dushed-border {
      border: 1px dashed;
      border-left: none;
      border-right: none;
    }

    .qrcode-container {
      width: 140px;
      margin: auto;
      margin-bottom: 10px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
    .qrcode img {
      width: 100%;
      height: 100%;
    }
  </style>
</head>
<body>
  <div class="receipt">
    <div class="receipt-header freg">
      <div class="ftitle f-bold f-center">{{ groupInfo.name }}</div>
    </div>

    <div class="receipt-info">
      <div class="d-flex fl-jsb mb-10 freg">
        <div style="width: 55%">{{ date }} {{ hour }}</div>
        <div class="d-flex fl-col fl-ae f-reg">
          <div>{{ sellerName }}</div>
        </div>
      </div>
      <hr class="mb-10" />
      <div class="d-flex fl-jsb mb-10">
        <div>Ref:</div>
        <div><span class="f-bold">{{ bookingRef }}</span></div>
      </div>
      <div class="d-flex fl-jsb mb-10">
        <div>Order:</div>
        <div class="f-bold">{{ replaceHash orderName }}</div>
      </div>
      <hr />
    </div>

    <div class="receipt-products">
      {{#each products}}
      <div class="mb-10">
        <div class="product d-flex">
          <div class="d-flex fl-col" style="width: 50%">
            <div>{{ replaceHash this.name}}</div>
            <div class="fsmall">{{ replaceHash this.priceName }}</div>
          </div>
          <div class="d-flex fl-col fl-jc" style="width: 10%">
            <div>x{{ this.quantity }}</div>
          </div>
          <div class="d-flex fl-col fl-ae fl-jc fl-grow">
          </div>
        </div>
        {{#if hasCancelledTickets}}
        <div class="d-flex mt-5">
          <div class="d-flex fl-col" style="width: 50%">
            <div class="freg">{{ ../fieldCancellation }}</div>
          </div>
          <div class="d-flex fl-col fl-jc" style="width: 10%">
            <div>x{{ this.quantityCancelled }}</div>
          </div>
          <div class="d-flex fl-col fl-ae fl-jc fl-grow">
          </div>
        </div>
        {{/if}}

      </div>
      {{/each}}
    </div>

    <hr class="mb-10" />
  </div>
</body>
`;
